import { render } from "./zdsx.vue?vue&type=template&id=2ac422f8&scoped=true&ts=true"
import script from "./zdsx.vue?vue&type=script&lang=ts"
export * from "./zdsx.vue?vue&type=script&lang=ts"

import "./zdsx.vue?vue&type=style&index=0&id=2ac422f8&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac422f8"]])

export default __exports__